export default __webpack_public_path__ + "static/media/4251.8deace98.png";